import { useState } from 'react'

import { Box } from '@fairfashion/design-system'
import { Outlet } from 'react-router-dom'

import { ChatAI } from '../ChatAI/chat-ai.comp'
import { Header } from '../Header/header.comp'
import { Sidebar } from '../Sidebar/sidebar.comp'

import * as Styles from './layout.styles'

export const Layout = () => {
  const [sidebarOpened, setSidebarOpened] = useState(false)

  return (
    <Box backgroundColor="primary" width="100%" height="100%">
      <Sidebar open={sidebarOpened} onClose={() => setSidebarOpened(false)} />
      <Box flex={1} direction="column" height="100%">
        <Header toggleSidebar={() => setSidebarOpened(!sidebarOpened)} />
        <Styles.Content
          flex={1}
          backgroundColor="white"
          width="100%"
          height="100%"
        >
          <Outlet />
        </Styles.Content>
      </Box>

      <ChatAI />
    </Box>
  )
}
